<template>
  <div>
    <div class="row border-bottom border-danger">
      <div class="w-100 text-center mt-3">
        <h3>ARTICLES AT LOCATION</h3>
      </div>
      <b-form-group class="mt-3 col-7 form-inline">
        <b-form-select
          class="mr-3"
          v-model="selectors.rafa"
          :options="locations.rafe"></b-form-select>
        <b-form-select
          class="mr-3"
          v-model="selectors.kolona"
          :disabled="!selectors.rafa"
          :options="locations.kolone"></b-form-select>
        <b-form-select
          class="mr-3"
          v-model="selectors.red"
          :disabled="!selectors.kolona"
          :options="locations.redovi"></b-form-select>
        <b-form-select
          class=""
          placeholder="Select Box"
          v-model="selectors.box"
          :disabled="!selectors.red"
          :options="shelfBoxes"></b-form-select>
        <b-button size="md"
          :disabled="!selectors.rafa || !selectors.kolona || !selectors.red"
          @click="getParts"
          href="#"
          variant="success"
          class="ml-1">
          <b-icon-search></b-icon-search>
        </b-button>
      </b-form-group>

      <div class="mt-3 col-5">
        <b-form-input
          class="w-50 float-right"
          v-model="scannedBox"
          v-on:keyup.enter="findScanned"
          type="text"
          name="scanned"
          id="scanned"
          placeholder="Select input and scan"></b-form-input>
      </div>
    </div>
    <div class="w-100 position-relative" v-if="loading">
      <div class="w-100 mt-5 position-absolute text-center">
        <b-icon class="text-dark" icon="arrow-clockwise" animation="spin" font-scale="3"></b-icon>
      </div>
    </div>

    <div v-else-if="products.length && !loading">
      <div class="row mt-3 overflow-hidden">
        <table class="table" ref="articles">
          <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Updated</th>
            <th scope="col">SKU</th>
            <th class="d-none d-sm-table-cell" scope="col">Name</th>
            <th class="d-none d-sm-table-cell" scope="col">Local Count</th>
            <th class="d-none d-sm-table-cell" scope="col">Scanned</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(val, i) of products" v-bind:key="i" :class="getRowClass(val)">
            <td>{{i+1}}</td>
            <td>{{!val.updatedAt ? "No updates" : moment(val.updatedAt).format('DD.MM.YYYY HH:mm')}}</td>
            <td>{{val.codename}}</td>
            <td @click="showImage(val)" class="pointer">{{val.name}}</td>
            <td class="text-center">{{val.localCount || 0}}</td>
            <td :class="[scannedIndex === i ? 'bg-info text-white' : '', 'text-center']">{{val.scanned || 0}}</td>
          </tr>
          </tbody>
        </table>
        <b-modal ref="image-modal" id="image-modal" hide-footer title="Product image">
          <div class="d-block text-center">
            <b-img :src="articleImage" fluid alt="No image"></b-img>
          </div>
          <b-button class="mt-3" variant="outline-danger" block @click="$bvModal.hide('image-modal')">Close</b-button>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import fixed from '@/fixed';

const BASE_API_URL = fixed.API_URL;
export default {
  name: 'ProductsOnLocation.vue',
  data: () => ({
    loading: false,
    errorAudio: null,
    selectors: {
      rafa: '',
      kolona: '',
      red: '',
      box: '',
    },
    locations: fixed.locations,
    products: [],
    articleImage: null,
    scannedBox: '',
    scannedIndex: null,
    shelfBoxes: [{ value: '', text: 'Select Box', disabled: true }],

    moment,
  }),
  mounted() {
    this.generateBoxes();
    this.initAudio();
  },
  beforeDestroy() {
    if (this.errorAudio) {
      this.errorAudio.pause();
      this.errorAudio = null;
    }
  },
  methods: {
    initAudio() {
      if (!this.errorAudio) {
        this.errorAudio = new Audio('/error.mp3');
        this.errorAudio.preload = 'auto';
      }
    },
    playErrorSound() {
      if (this.errorAudio) {
        this.errorAudio.currentTime = 0;
        this.errorAudio.play();
      }
    },
    async getParts() {
      if (!this.selectors.rafa || !this.selectors.kolona || !this.selectors.red) {
        this.$toast.warning('All selectors are required to build location');
        return;
      }

      this.loading = true;
      try {
        const result = await axios.get(`${BASE_API_URL}/admin/products-on-location`, {
          withCredentials: true,
          params: { l: `${this.selectors.rafa} ${this.selectors.kolona} ${this.selectors.red} ${this.selectors.box}` },
        });
        this.products = result.data || [];
        this.findScanned();
      } catch (e) {
        this.$toast.error('can\'t get articles for this location');
        console.error(e); // eslint-disable-line
      }
      this.loading = false;
    },
    showImage(article) {
      this.articleImage = article?.images?.image[0]?.url || null;
      if (!this.articleImage) return;

      this.$refs['image-modal'].show();
    },
    findScanned() {
      if (!this.scannedBox) return;
      let found = false;

      for (let i = 0; i < this.products.length; i += 1) {
        for (let j = 0; j < this.products[i].productCodes.productCode.length; j += 1) {
          const p = this.products[i].productCodes.productCode[j];
          if (p.type === 'ean' && p.code === this.scannedBox) {
            // increment scanned count
            this.products[i].scanned = this.products[i].scanned ? this.products[i].scanned += 1 : 1;
            // store index to highlight on the page
            this.scannedIndex = i;
            // scroll article into the view
            this.$nextTick(() => {
              const rows = this.$refs.articles.querySelectorAll('tr');
              rows[i].scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              });
            });
            found = true;
            // no need to look further
            break;
          }
        }
      }

      if (!found) {
        this.$toast.error('product with that code is not on the list');
        this.playErrorSound();
      }
      this.scannedBox = '';
    },
    getRowClass(p) {
      let color = '';
      if (p.localCount === p.scanned) {
        color = ['bg-success'];
      } else if (p.localCount < p.scanned) {
        color = ['bg-warning', 'text-dark'];
      }

      return color;
    },
    generateBoxes() {
      for (let i = 1; i <= 250; i += 1) {
        this.shelfBoxes.push({ value: `Box${i}`, text: `Box ${i}` });
      }
    },
  },
};
</script>

<style scoped>

</style>
